import { colors } from 'theme'

export const defaultThemeStyles = {
    background: 'rgba(0, 0, 0, 0.9)',
    text: colors.white,
    error: colors.error,
}
